'use strict';
import Component from 'gia/Component';
import Channels from '../base/channels';
import { RevealMask,RevealFadeOut } from '../fx/Common'

export default class HomeView extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element;

    //! Fns
    this.funcLaunch = this._fx.bind(this)
    Channels.on('launcher::exit',this.funcLaunch)
    Channels.on('transition::end',this.funcLaunch)
  }

  _fx()
  {
    RevealFadeOut(this.DOM.view.querySelector('.js-cacheseo'))
    RevealMask(this.DOM.view.querySelector('.js-mask'))
  }

}
